export default __webpack_public_path__ + "static/media/chat-icon.624a15c8.svg";